import React, { PropsWithChildren } from "react";

type PropTypes = PropsWithChildren & {
  on: boolean;
  Wrapper: React.ElementType<PropsWithChildren>;
};

export const ConditionalWrapper: React.FC<PropTypes> = ({
  Wrapper,
  on,
  children,
}) => {
  if (on) {
    return <Wrapper>{children}</Wrapper>;
  }
  return <>{children}</>;
};
